import { ColumnsType } from "antd/es/table";
import { ExamPeriod, User } from "@types";
import { Typography } from "antd";
import { Translation } from "react-i18next";
import { ExamParticipantTableActions } from "../components/exam-period/ExamParticipantTableActions";
import { TableFilterDropdown } from "@components";
import { Search } from "lucide-react";

export const userTable = (examPeriod: ExamPeriod): ColumnsType<User> => [
    {
        title: <Translation> 
        {
            t => t("table.nameLastname")
        }
        </Translation>,
        key: "text",
        filterSearch: true,
        filterIcon: (filtered: boolean) => (
            <Search style={{ color: filtered ? "#F1B80E" : undefined }} />
            ),
        onFilter: (value: any, record) => `${record.firstName.toLowerCase()} ${record.lastName.toLowerCase()}`.includes(value.toLowerCase()),
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <TableFilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters} prefixCls={""} close={function (): void {
                throw new Error("Function not implemented.");
            } } visible={false}/>
          ),
        render(_, record) {
            return <Typography.Text>{record.firstName} {record.lastName}</Typography.Text>
        },
    },
    {
        title: <Translation>{(t) => t("table.oib")}</Translation>,
        dataIndex: "oib",
        key: "oib"
    },
    {
        title: <Translation> 
        {
            t => t("table.email")
        }
        </Translation>,
        dataIndex: "email",
        key: "email"
    },
    {
        title: <Translation> 
        {
            t => t("table.actions")
        }
        </Translation>,
        key: "actions",
        render(_, record) {
            return <ExamParticipantTableActions participant={record} examPeriod={examPeriod}/>
        },
    }
]